// extracted by mini-css-extract-plugin
export default {"categories-content-section":"ReportCategoriesContentSection_categories-content-section__NlS+y"};